import * as angular from "angular";
import {IController, IScope} from "angular";
import * as _ from "lodash";

export class customersTableRowCtrl implements IController {

  customerId: any;
  onDelete: Function;
  onEdit: Function;

  private customer: any;

  /* @ngInject */
  constructor(private $customers, private $scope: IScope) {
  }

  $onInit() {
    if (this.customerId) {
      this.$customers(this.customerId).$bindCtrlToId(this.$scope, this, 'customer', 'customerId');
    }
  }

  $onChanges(changes) {
    if (changes.customerId && !changes.customerId.isFirstChange()) {
      this.$onInit();
    }
  };

  getCustomerDefaultAddress(addressId) {
    return addressId ? _.find(this.customer.addresses, (address) => {
      return address.id === addressId;
    }) : undefined;
  }


}

angular
  .module('bringoz.admin.customers')
  .component('customersTableRow', {
    bindings: {
      customerId: '<',
      onEdit: '&',
      onDelete: '&'
    },
    template: require('./customers-table-row.html').default,
    controller: customersTableRowCtrl
  });
